import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["commentsSection"]
  static values = { id: Number }

  toggleComments() {
    this.commentsSectionTarget.classList.toggle("hidden")

    if (!this.commentsSectionTarget.classList.contains("hidden")) {
      const input = this.commentsSectionTarget.querySelector("input[type='text']")
      if (input) {
        input.focus()
      }
    }
  }
}
